import { initializeGoogleAds, initializeWhatsAppClickTracking } from "./lib/google-ads";

// Basic Consent Mode: no Google request is made until the visitor accepts.
initializeGoogleAds();
initializeWhatsAppClickTracking();
